import axios from "axios";
export default {
  async getAll() {
    try {
      const response = await axios.get(
        "https://api.first.org/data/v1/countries?limit=400",
        { withCredentials: false }
      );
      return response.data.data; // API response format: { status: "...", data: {...} }
    } catch (error) {
      console.error("Error fetching countries:", error);
      throw error;
    }
  },
};
